// extracted by mini-css-extract-plugin
export var deliveryRow = "_t3-a";
export var fixedHeight = "_t3-4";
export var freightLogo = "_t3-9";
export var fullWidth = "_t3-3";
export var priceColumn = "_t3-5";
export var radioSelected = "_t3-7";
export var radioUnselected = "_t3-6";
export var selectedOption = "_t3-2";
export var selectedOptionContainer = "_t3-1";
export var selection = "_t3-0";
export var tallSkeletonText = "_t3-8";